// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2j1vN","container":"styles_container__3azGX","title":"styles_title__2YE3h","wrapper":"styles_wrapper__3Lchb","answer":"styles_answer__3SGqt"};